export const getCurrencyValue = (state) => {
    return state.currency
};
export const getCurrencyObject = (state) => {
    return state.currencyObject
};
export const getLanguageValue = (state) => {
    return state.languge
};
export const getPageValue = (state) => {
    return state.page
};
export const getPageParamValue = (state) => {
    return state.pageParam
};
export const getFullDataBase = (state) => {
    return state.fullDataBase
};
export const getUsersDataBase = (state) => {
    return state.usersDataBase  
};
export const getRegionsDataBase = (state) => {
    return state.regions
};
export const getChosenObject = (state) => {
    return state.chosenObject
};
export const getSorterValue = (state) => {
    return state.sorterValue
};
export const getAgreementrValue = (state) => {
    return state.agreementValue
};
export const getInputsValue = (state) => {
    return state.formInput
};
export const getSearchValue = (state) => {
    return state.searchInput
};
export const getMainSearchValue = (state) => {
    return state.mainSearchInput
};